document.addEventListener("DOMContentLoaded", function () {
  const themeSettings = window.theme && window.theme.settings ? window.theme.settings : null;
  const isRelatedProductsEnabled =
    themeSettings &&
    themeSettings.related_products_enabled;
  const isCategoriesModeEnabled =
    themeSettings &&
    themeSettings.upsell_show_categories_mode;

  if (
    !themeSettings ||
    (!isRelatedProductsEnabled && !isCategoriesModeEnabled)
  ) {
    return;
  }

  const THRESHOLD = parseInt(
    theme.settings.related_products_threshold || "150000",
    10
  );
  const COLLECTION_A =
    theme.settings.related_products_collection_a || "complementarios-a";
  const COLLECTION_B =
    theme.settings.related_products_collection_b || "complementarios-b";

  const contenedorPopup = document.querySelector(".pt-upsell-popup-wrapper");
  const modalPopup = document.querySelector("#modalAddToCartProduct");
  let categoriasAutoplayInterval = null;

  if (!contenedorPopup || !modalPopup) {
    return;
  }

  function obtenerSubtotalCarrito() {
    const totalElement = document.querySelector(
      ".pt-cart-total-price, .pt-modal-product .pt-price"
    );
    if (!totalElement) return 0;

    const texto = totalElement.textContent || "";
    const valorNumerico = parseInt(texto.replace(/[^\d]/g, ""), 10);
    return isNaN(valorNumerico) ? 0 : valorNumerico;
  }

  function getRandomProducts(arr, count) {
    return arr.sort(() => Math.random() - 0.5).slice(0, count);
  }

  function normalizeShopifyLink(value) {
    if (!value || value === "#") return "#";
    if (typeof value !== "string") return "#";
    if (!value.startsWith("shopify://")) return value;

    const match = value.match(/^shopify:\/\/(pages|collections|products)\/(.+)$/);
    if (match) {
      return `/${match[1]}/${match[2]}`;
    }

    return "#";
  }

  function renderCategoriasSugeridas() {
    if (categoriasAutoplayInterval) {
      clearInterval(categoriasAutoplayInterval);
      categoriasAutoplayInterval = null;
    }

    const categorias = [1, 2, 3].map((i) => ({
      titulo: theme.settings[`upsell_category_${i}_title`] || "",
      imagen:
        theme.settings[`upsell_category_${i}_image_url`] ||
        theme.settings[`upsell_category_${i}_image`] ||
        "",
      link: normalizeShopifyLink(theme.settings[`upsell_category_${i}_link`]),
    }))
    .filter((cat) => cat.titulo && cat.imagen);

    if (!categorias.length) {
      contenedorPopup.style.display = "none";
      return;
    }

    const htmlCategorias = categorias.map((cat) => `
      <div class="pt-categoria">
        <a href="${cat.link}" target="_blank" rel="noopener noreferrer" class="pt-categoria-link">
          <img src="${cat.imagen}" alt="${cat.titulo}" />
          <div class="pt-categoria-titulo">${cat.titulo}</div>
        </a>
      </div>
    `).join("");

    if (categorias.length === 1) {
      contenedorPopup.innerHTML = `
        <div class="pt-upsell-popup-title">${theme.settings.upsell_popup_heading_text || "Categorías recomendadas"}</div>
        <div class="pt-upsell-categoria-single">
          ${htmlCategorias}
        </div>
      `;
      contenedorPopup.style.display = "block";
      return;
    }

    const dotsHtml = categorias
      .map((_, index) => `<button class="pt-categoria-dot${index === 0 ? " active" : ""}" data-index="${index}" aria-label="Ir a categoría ${index + 1}"></button>`)
      .join("");

    contenedorPopup.innerHTML = `
      <div class="pt-upsell-popup-title">${theme.settings.upsell_popup_heading_text || "Categorías recomendadas"}</div>
      <div class="pt-upsell-categorias-carousel">
        <div class="pt-upsell-categorias-track">
          ${htmlCategorias}
        </div>
      </div>
      <div class="pt-upsell-categorias-dots">
        ${dotsHtml}
      </div>
    `;

    contenedorPopup.style.display = "block";

    const track = contenedorPopup.querySelector(".pt-upsell-categorias-track");
    const dots = Array.from(contenedorPopup.querySelectorAll(".pt-categoria-dot"));
    if (!track || !dots.length) return;

    let currentIndex = 0;
    const totalSlides = categorias.length;

    function goToSlide(index) {
      currentIndex = index;
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      dots.forEach((dot, idx) => {
        dot.classList.toggle("active", idx === currentIndex);
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener("click", function () {
        const index = parseInt(this.getAttribute("data-index"), 10);
        if (!isNaN(index)) {
          goToSlide(index);
        }
      });
    });

    categoriasAutoplayInterval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % totalSlides;
      goToSlide(nextIndex);
    }, 3000);
  }

  function cargarProductos(coleccion) {
    const productoAgregado =
      modalPopup.querySelector(".pt-title")?.textContent?.trim() || "";
    const color =
      modalPopup.querySelector(".pt-add-info li:nth-child(1)")?.textContent?.trim() || "";
    const talla =
      modalPopup.querySelector(".pt-add-info li:nth-child(2)")?.textContent?.trim() || "";
    const cantidad =
      modalPopup.querySelector(".pt-qty span")?.textContent?.trim() || "1";
    const precio =
      modalPopup.querySelector(".pt-qty .cur-product-js")?.textContent?.trim() || "";

    fetch(`/collections/${coleccion}/products.json?limit=50`)
      .then((res) => res.json())
      .then((data) => {
        if (!data.products || data.products.length === 0) {
          return cargarProductos("all");
        }

        let productos = data.products;

        if (theme.settings.upsell_randomize_products) {
          if (productos.length > 9) {
            productos = getRandomProducts(productos, 9);
          }
        }

        const html = productos
          .slice(0, 9)
          .map((p) => {
            const rawPrecio = p.variants?.[0]?.price || 0;
            const rawComparacion = p.variants?.[0]?.compare_at_price || 0;
            const precio = parseFloat(rawPrecio);
            const precioRedondeado = precio;
            const comparacion = parseFloat(rawComparacion);

            let precioHtml = "";
            if (theme.settings.upsell_show_prices) {
              const precioCOP = precioRedondeado.toLocaleString("es-CO", {
                style: "currency",
                currency: "COP",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              });
              const comparacionCOP = comparacion.toLocaleString("es-CO", {
                style: "currency",
                currency: "COP",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              });

              precioHtml =
                comparacion > precio
                  ? `<div class="pt-precio">
                        <span class="tachado">${comparacionCOP}</span>
                        <span class="oferta">${precioCOP}</span>
                     </div>`
                  : `<div class="pt-precio">${precioCOP}</div>`;
            }
            return `
              <div class="producto-item">
                <a href="/products/${p.handle}" title="${p.title}">
                  <img src="${p.images?.[0]?.src || ""}" style="max-width:100%" />
                  <div class="tituloproductopopup">${p.title}</div>
                  ${precioHtml}
                </a>
              </div>`;
          })
          .join("");

        contenedorPopup.innerHTML = `
    <p class="pt-upsell-resumen">✅ Agregaste: ${productoAgregado} - ${color} / ${talla} - ${cantidad} x ${precio}</p>
    ${
      theme.settings.upsell_popup_banner_url
        ? `<div class="pt-upsell-popup-banner">
              <a href="${theme.settings.upsell_popup_banner_link || "#"}" target="_blank">
                <img src="${theme.settings.upsell_popup_banner_url}" alt="Upsell banner" style="max-width:100%;margin-bottom:10px;" />
              </a>
          </div>`
        : ""
    }
    ${
      theme.settings.upsell_popup_heading_text &&
      theme.settings.upsell_popup_heading_text !== "#"
        ? `<div class="pt-upsell-popup-title">${theme.settings.upsell_popup_heading_text}</div>`
        : ""
    }
    <div class="pt-upsell-carousel-wrapper">
      <div class="pt-upsell-carousel-scroll">
        ${html}
      </div>
    </div>
  `;

        contenedorPopup.innerHTML += `
          <div class="pt-carousel-controls">
            <button class="pt-carousel-btn left" aria-label="Anterior">‹</button>
            <button class="pt-carousel-btn right" aria-label="Siguiente">›</button>
          </div>
        `;

        contenedorPopup.innerHTML += `
          <div class="pt-upsell-vermas-wrapper" style="text-align: center; margin-top: 10px;">
            <a href="/collections/${coleccion}" class="pt-upsell-vermas">
              Ver toda la colección
            </a>
          </div>
        `;

        contenedorPopup.style.display = "block";

        const scrollContainer = document.querySelector(".pt-upsell-carousel-scroll");

        const btnLeft = document.querySelector(".pt-carousel-btn.left");
        const btnRight = document.querySelector(".pt-carousel-btn.right");

        if (btnLeft && scrollContainer) {
          btnLeft.addEventListener("click", () => {
            scrollContainer.scrollLeft -= 240;
          });
        }

        if (btnRight && scrollContainer) {
          btnRight.addEventListener("click", () => {
            scrollContainer.scrollLeft += 240;
          });
        }

        scrollContainer.setAttribute("touch-action", "pan-x");

        let autoplayInterval;
        function startAutoplay() {
          autoplayInterval = setInterval(() => {
            if (scrollContainer) {
              scrollContainer.scrollLeft += 240;
            }
          }, 5000);
        }

        function stopAutoplay() {
          clearInterval(autoplayInterval);
        }

        if (scrollContainer) {
          scrollContainer.addEventListener("mouseenter", stopAutoplay);
          scrollContainer.addEventListener("touchstart", stopAutoplay);
          scrollContainer.addEventListener("mouseleave", startAutoplay);
          startAutoplay();
        }
      })
      .catch((err) => {
        console.error("[UPSELL POPUP] Error cargando productos:", err);
      });
  }

  // Detectar cuándo se abre el modal
  $("#modalAddToCartProduct").on("shown.bs.modal", function () {
    const subtotal = obtenerSubtotalCarrito();
    const umbral = parseInt(
      theme.settings.related_products_threshold || "150000",
      10
    );
    const coleccion =
      subtotal >= umbral
        ? theme.settings.related_products_collection_b
        : theme.settings.related_products_collection_a;
    if (theme.settings.upsell_show_categories_mode) {
      renderCategoriasSugeridas();
    } else {
      cargarProductos(coleccion);
    }
  });

  $("#modalAddToCartProduct").on("hide.bs.modal", function () {
    if (categoriasAutoplayInterval) {
      clearInterval(categoriasAutoplayInterval);
      categoriasAutoplayInterval = null;
    }
  });
});
